import { useEffect, useState } from "react"

import { Button, Reorderable } from "web/components"
import { ReorderIcon } from "web/components/Icon"
import useShowSectionModal from "./Show"

import { useFormSections } from "web/hooks/data"
import { useDialogModal, Dialogs, DialogCommands } from "web/hooks/modals"

const ALL_FIELDS_SECTION_ID = -1

export default function FormSectionsList({ subjectType, topicId }) {
  const sections = useFormSections({ subjectType, topicId })
  const [_sections, setSections] = useState(sections)

  useEffect(() => {
    setSections(sections)
  }, [sections])

  const showSectionModal = useShowSectionModal()
  const dialogModal = useDialogModal()
  const addSectionModal = useDialogModal(Dialogs.New("section"))

  const configurableSections = sections.filter(
    (el) => el.id !== ALL_FIELDS_SECTION_ID
  )
  const hasSections = configurableSections.length > 0

  async function handleAddSection() {
    const dialogResult = await addSectionModal()

    if (dialogResult && dialogResult.response) {
      const newSection = await sections.add({ label: dialogResult.inputValue })
      if (newSection.label === undefined) {
        dialogModal({
          title: "Add Section",
          prompt: "Could not add section. Section names must be unique.",
          commands: [DialogCommands.OK],
        })
      } else {
        showSectionModal(newSection, subjectType)
      }
    }
  }

  async function handleEditSection(section, subjectType) {
    showSectionModal(section, subjectType)
  }

  function handleMoveSection(fromIndex, toIndex) {
    const sectionsReordered = [..._sections]
    const [sectionToMove] = sectionsReordered.splice(fromIndex, 1)
    sectionsReordered.splice(toIndex, 0, sectionToMove)

    setSections(sectionsReordered)
    sections.reorder(fromIndex + 1, toIndex + 1)
  }

  return (
    <div>
      <div className="mb-2.5">
        <Button onClick={handleAddSection}>Add Section</Button>
      </div>
      {hasSections && (
        <Reorderable
          id="sections"
          itemContainerClass="h-10 grid items-center bg-white shadow rounded-md"
          itemListClass="grid auto-rows-auto gap-y-2.5"
          onMoveItem={handleMoveSection}
        >
          {configurableSections.map((section) => (
            <div
              key={section.label}
              className="grid items-center gap-x-2.5 px-2.5 py-0"
              style={{ gridTemplateColumns: "20px 1fr" }}
            >
              <ReorderIcon />
              <span
                className="cursor-pointer text-primary-4 hover:text-feature-6"
                onClick={() => handleEditSection(section, subjectType)}
              >
                {section.label}
              </span>
            </div>
          ))}
        </Reorderable>
      )}
      {!hasSections && (
        <div className="flex items-center justify-center rounded-md bg-neutral-6 p-5 text-white shadow-md">
          <p>
            There are no sections for this entity. Click the <b>Add Section</b>{" "}
            button to create one.
          </p>
        </div>
      )}
    </div>
  )
}
